export const MODULE_NAME = 'axp-benefits-activity';
export const BROWSE_BENEFITS_TAB_ID = 'tab-browse-benefits';
export const VIEW_BENEFITS_ACTIVITY_TAB_ID = 'tab-view-benefits-activity';

export const ENROLL_STATES = [
  'ENROLLED',
  'FAILED',
  'LOGGEDIN',
  'NOTENROLLED',
  'NOTLOGGEDIN',
  'OPENWINDOW',
  'PENDING',
  'REJECTED',
  'SUPP',
  'UNKNOWN',
];
export const amexAssuranceDisclosures = '♦Amex Assurance Disclosures';
export const benefitsTerms = '‡Benefits Terms';
export const benefitsYouCanEnrollIn = 'Benefits You Can Enroll In';
export const browseBenefits = 'Browse Benefits';
export const enrollableStatus = ['PENDING', 'NOTENROLLED', 'OPENWINDOW', 'REJECTED'];
export const exploreAmexPartners = 'Explore Amex Partners';
export const maximizeMembership = 'Maximize your membership by exploring perks and benefits with some of your favorite retailers and restaurants.';
export const trackProgress = 'Track Progress';
export const viewBenefitsActivity = 'View Benefits Activity';
export const viewTerms = 'View Benefit Terms';
